import { render, staticRenderFns } from "./List-transferencia.vue?vue&type=template&id=1f628013&scoped=true&"
import script from "./List-transferencia.vue?vue&type=script&lang=js&"
export * from "./List-transferencia.vue?vue&type=script&lang=js&"
import style0 from "./List-transferencia.vue?vue&type=style&index=0&id=1f628013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f628013",
  null
  
)

export default component.exports